import { render, staticRenderFns } from "./BookletPdf.vue?vue&type=template&id=63c2a420&"
import script from "./BookletPdf.vue?vue&type=script&lang=js&"
export * from "./BookletPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports